var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496 496",
    style: {
      enableBackground: "new 0 0 496 496"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,0v400h133.992C120.336,412,112,429.424,112,448v48h48v-48c0-8.824,7.176-16,16-16c8.824,0,16,7.176,16,16v48h48v-48 c0-18.576-8.336-36-21.992-48H288v56c0,22.056,17.944,40,40,40c22.056,0,40-17.944,40-40v-56h128V0H0z M224,448v32h-16v-32 c0-17.648-14.352-32-32-32s-32,14.352-32,32v32h-16v-32c0-18.384,10.768-35.384,27.44-43.312l4.56-2.176V221.488l-4.56-2.168 C138.768,211.384,128,194.384,128,176v-32h16v32c0,17.648,14.352,32,32,32s32-14.352,32-32v-32h16v32 c0,18.384-10.768,35.384-27.44,43.312l-4.56,2.176V402.52l4.56,2.168C213.232,412.616,224,429.616,224,448z M288,384h-80v-16h80 V384z M352,456c0,13.232-10.768,24-24,24s-24-10.768-24-24V336h16v24h16v-24h16V456z M312.68,173.368L318.56,144h18.88 l5.872,29.368l-7.312,7.32V320h-16V180.688L312.68,173.368z M352,320V187.312l8.68-8.68L350.56,128h-45.12l-10.128,50.632 l8.688,8.68V320h-32v16h16v16h-80V231.36C227.592,220,240,198.8,240,176v-48h-48v48c0,8.824-7.176,16-16,16 c-8.824,0-16-7.176-16-16v-48h-48v48c0,22.8,12.408,44,32,55.36V352H48V112h400v240h-80v-16h16v-16H352z M480,384H368v-16h96V96 H32v272h112v16H16V80h464V384z M480,64H16V16h464V64z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 32,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 32,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 376,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368,
    y: 248,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 248,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 248,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 248,
    width: 16,
    height: 16
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSite);
export default __webpack_public_path__ + "static/media/site.d43e4fd4d23bd655c4eb708408e93a3a.svg";
export { ForwardRef as ReactComponent };